"use client";

import { FlyOutData } from "../../helpers/data/getFlyOutData";
import { RailFlyOver } from "./RailFlyOver";
import classNames from "classnames/bind";
import React, { useEffect, useRef } from "react";
import styles from "./RailFlyOverModal.module.css";

const cx = classNames.bind(styles);

export const RailFlyOverModal = ({
  isOpen = true,
  onClose,
  categories,
  featuredProducts,
  title,
}: {
  title: FlyOutData["title"];
  featuredProducts: FlyOutData["featuredProducts"];
  categories: FlyOutData["categories"];
  isOpen?: boolean;
  onClose: () => void;
}) => {
  const modalOverlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const abortController = new AbortController();

    window.addEventListener(
      "keydown",
      (event: KeyboardEvent) => {
        if (isOpen && event.key === "Escape") {
          event.stopPropagation();
          onClose();
        }
      },
      { signal: abortController.signal },
    );

    return () => abortController.abort();
  }, [isOpen, onClose]);

  return (
    <div className={cx("modalOverlay")} data-is-open={isOpen}>
      <div
        ref={modalOverlayRef}
        className={cx("flyOverContainer")}
        data-is-open={isOpen}
        onClick={(event) => {
          if (event.target === modalOverlayRef.current) {
            onClose();
          }
        }}
      >
        <RailFlyOver
          onClose={onClose}
          categories={categories}
          featuredProducts={featuredProducts}
          title={title}
        />
      </div>
    </div>
  );
};
